<opac-user-title
  [title]="'user.history' | translateByCustomerType: customerType.dbValue"
  [skeleton]="isLoading"
></opac-user-title>


<div>
  <ng-container *ngIf="!isLoading">
    <opac-no-results *ngIf="!userService.history.items.length" [label]="'user.history.noHistory' | translate">
      <opac-no-results-cta>
        {{ 'user.history.browse' | translate }}
        <opac-button type="secondary" (click)="explore()">
          {{ 'search.explore' | translate }}
        </opac-button>
      </opac-no-results-cta>
    </opac-no-results>

    <export-button
      *ngIf="userService.history.items.length && showEnableUserHistoryExport"
      class="export-button"></export-button>

    <app-record-card-grid>
      <app-user-history-item
        *ngFor="let historyItem of userService.history.items"
        (removed)="onRemoved($event)"
        [historyItem]="historyItem"
        class="list__item"></app-user-history-item>
    </app-record-card-grid>

    <opac-infinite-scroll
      [disabled]="isLastPage || waiting"
      [threshold]="100"
      (load)="loadMore()"></opac-infinite-scroll>
  </ng-container>
</div>

<app-user-history-stats-dialog></app-user-history-stats-dialog>

<ng-container *ngIf="isLoading">
  <app-record-card-grid>
    <ng-container *ngFor="let i of [1, 2, 3, 4]; let last = last; let first = first">
      <card-item-skeleton></card-item-skeleton>
      <opac-skeleton *ngIf="!last" class="hide-tablet" style="height: 1px; margin: 0 -16px"></opac-skeleton>
    </ng-container>
    <opac-gradient></opac-gradient>
  </app-record-card-grid>
</ng-container>
